import importerReducers from '../../../modules/shared/importer/importerReducers'
import actions from '../../../modules/courseComment/importer/courseCommentImporterActions'

export default importerReducers(actions)
